export default __webpack_public_path__ + "locales/si/Ldap.json?hash=669ff5d237e3e94c81a3e07441deeada";